var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogicalTestIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 300 305.69",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2fbaba;}.cls-2{isolation:isolate;}.cls-3{mix-blend-mode:multiply;}.cls-4{fill:#8eedd4;}.cls-5{clip-path:url(#clip-path);}.cls-6{fill:#a59b9b;}.cls-7{fill:#453333;}.cls-8{fill:#e9dada;}.cls-9{fill:#d3c2c2;}.cls-10{fill:#f29853;}.cls-11{fill:#ffad76;}.cls-12{fill:#fff;}.cls-13{fill:#614d4c;}.cls-14{fill:#4e3e3e;}.cls-15{fill:#6c5454;}.cls-16{fill:#e08a4f;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150,
    cy: 154.66,
    r: 150
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "intellect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3",
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 150,
    cy: 154.66,
    r: 150
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150,
    cy: 154.66,
    r: 150
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "215 305.69 216.07 206.83 82.92 206.83 82.25 305.69 215 305.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M212.88,238.26c0-40.85-132-40.85-132,0l2-31.43H216.07Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 73.53,
    width: 149.84,
    height: 170.9,
    rx: 71.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M183.32,31.27a5.48,5.48,0,0,1-.33-8.48,5.62,5.62,0,0,1,7.12-.13c.52.4,1,.81,1.55,1.23a7.62,7.62,0,0,0,10.22-.45l1.34-1.33A71.65,71.65,0,0,0,151.51,0h-6.12A72.08,72.08,0,0,0,73.53,71.86V99A71.3,71.3,0,0,0,86,139.33l98-98a6.68,6.68,0,0,0-.6-10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M173.8,167.33a72.44,72.44,0,0,0,46-46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M76.36,155.59h0a9.81,9.81,0,0,1-9.78-9.78V107.67a9.82,9.82,0,0,1,9.78-9.79h0a9.82,9.82,0,0,1,9.78,9.79v38.14A9.81,9.81,0,0,1,76.36,155.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M223.37,155.59h0a9.81,9.81,0,0,1-9.78-9.78V107.67a9.82,9.82,0,0,1,9.78-9.79h0a9.82,9.82,0,0,1,9.78,9.79v38.14A9.81,9.81,0,0,1,223.37,155.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M223.37,138.43h0a4,4,0,0,1-4-4V119a4,4,0,0,1,4-4h0a4,4,0,0,1,4,4v15.46A4,4,0,0,1,223.37,138.43Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 84.33,
    y: 38.28,
    width: 131.08,
    height: 176.28,
    rx: 65.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M100,152.37v-45.2a65.74,65.74,0,0,1,65.54-65.54h0c1.94,0,3.86.11,5.77.28a64.92,64.92,0,0,0-21.4-3.63h0a65.73,65.73,0,0,0-65.53,65.54V149a65.75,65.75,0,0,0,59.76,65.27A65.78,65.78,0,0,1,100,152.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "137.6 144.17 142.27 97.89 117.46 155.59 137.6 144.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M208.21,215.14l-49.15,43.3a13.14,13.14,0,0,1-17.29.08L91.66,215.15a22,22,0,0,1-7.55-16.59v-51a1.74,1.74,0,0,1,3.34-.68l8,18.93a3,3,0,0,0,4.78.83l27.38-23.15a7.16,7.16,0,0,1,10,.7l1.35,1.52a13.81,13.81,0,0,0,20.72-.15l1.09-1.26a7.17,7.17,0,0,1,10-.8l27.84,23.25a3.05,3.05,0,0,0,4.73-.78l9-19.67a1.74,1.74,0,0,1,3.32.72v51.68A22,22,0,0,1,208.21,215.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M194.32,188.46A16.7,16.7,0,0,0,200,175.92v-8.49a3,3,0,0,1-1.37-.7l-27.84-23.25a7.17,7.17,0,0,0-10,.8l-1.09,1.26a13.81,13.81,0,0,1-20.72.15l-1.35-1.52a7.16,7.16,0,0,0-10-.7l-27.38,23.15a2.59,2.59,0,0,1-.5.37v8.85a16.72,16.72,0,0,0,5.76,12.63l22,19a34.5,34.5,0,0,0,45.41-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M164.44,181H135.29a8.49,8.49,0,0,1-8.47-8.46h0a8.49,8.49,0,0,1,8.47-8.47h29.15a8.49,8.49,0,0,1,8.47,8.47h0A8.49,8.49,0,0,1,164.44,181Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M187.75,85.45H163.16a6.26,6.26,0,0,1-6.24-6.25h0A6.26,6.26,0,0,1,163.16,73h24.59A6.26,6.26,0,0,1,194,79.2h0A6.27,6.27,0,0,1,187.75,85.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M131.32,91.7H106.73a6.27,6.27,0,0,1-6.25-6.25h0a6.28,6.28,0,0,1,6.25-6.25h24.59a6.27,6.27,0,0,1,6.25,6.25h0A6.27,6.27,0,0,1,131.32,91.7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 109.23,
    y: 98.26,
    width: 18.95,
    height: 5.83,
    rx: 2.91
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M124.14,105.76a5.44,5.44,0,1,1-5.43-5.44A5.43,5.43,0,0,1,124.14,105.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M139.92,97.88c-3.7,0-21.21,23.75-21.21,23.75h13.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 171.71,
    y: 98.26,
    width: 18.95,
    height: 5.83,
    rx: 2.91,
    transform: "translate(362.37 202.35) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M175.75,105.76a5.44,5.44,0,1,0,5.43-5.44A5.43,5.43,0,0,0,175.75,105.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M204.89,97.88c-3.69,0-21.21,23.75-21.21,23.75h13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M132.09,124.76H102.83a3.13,3.13,0,0,1-3-2.15L92,98.86a3.14,3.14,0,0,1,3-4.11h44.92a3.14,3.14,0,0,1,2.53,1.3,3.1,3.1,0,0,1,.44,2.81l-7.83,23.75A3.13,3.13,0,0,1,132.09,124.76Zm-27-6.26h24.72L135.59,101H99.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M197.05,124.76H167.8a3.13,3.13,0,0,1-3-2.15L157,98.86a3.1,3.1,0,0,1,.43-2.81,3.16,3.16,0,0,1,2.54-1.3h44.91a3.14,3.14,0,0,1,3,4.11L200,122.61A3.14,3.14,0,0,1,197.05,124.76Zm-27-6.26h24.73L200.55,101H164.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M156.88,98.84c-.35-.57-2.82-1.7-6.94-1.7s-6.58,1.13-6.93,1.7a.47.47,0,0,0,0-.17h-6.26c0-4.73,5.16-7.79,13.15-7.79s13.16,3.06,13.16,7.79h-6.26A.47.47,0,0,0,156.88,98.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M165.39,232.42h0a7.08,7.08,0,0,1-7.06-7.06V214.68a7.08,7.08,0,0,1,7.06-7.06h0a7.08,7.08,0,0,1,7.06,7.06v10.68A7.08,7.08,0,0,1,165.39,232.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M172.45,223.8h0a7.08,7.08,0,0,1-7.06-7.06V201.45a7.08,7.08,0,0,1,7.06-7.06h0a7.08,7.08,0,0,1,7.06,7.06v15.29A7.08,7.08,0,0,1,172.45,223.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M151.27,234.72h0a7.08,7.08,0,0,1-7.07-7.06V212.38a7.08,7.08,0,0,1,7.07-7.06h0a7.08,7.08,0,0,1,7.06,7.06v15.28A7.08,7.08,0,0,1,151.27,234.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M275.76,305.69l9.78-22.16A12.61,12.61,0,0,0,281.13,268L212.31,220.9l-27.7,46.68a184.93,184.93,0,0,0-17.12,38.11Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "292.02 305.69 286.26 281.01 275.44 305.69 292.02 305.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M23.48,305.69,11.61,279S9.82,289.51,8,305.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M23,305.69H131.31a185.43,185.43,0,0,0-17.11-38.11L86.49,220.9,17.67,268a12.61,12.61,0,0,0-4.41,15.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.33,305.69c12.94-20.41,30.47-48.38,39-61.95a11.08,11.08,0,0,0-2.13-14.24l-26.09-22.67-31,59.46,2.81,39.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M216.47,305.69l2.89-4.63A12.26,12.26,0,0,0,217,285.28l-28.91-25.13-24.18,38.68a52.84,52.84,0,0,0-3.61,6.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M93.66,305.69h17.5l2.81-39.4-31-59.46L56.83,229.5a11.08,11.08,0,0,0-2.13,14.24C63.19,257.31,80.72,285.28,93.66,305.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M82.52,305.69h56.17a52.84,52.84,0,0,0-3.61-6.86L110.9,260.15,82,285.28a12.27,12.27,0,0,0-2.35,15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M130.3,305.69l4.57-13.9-33-23.63A419.51,419.51,0,0,0,76,305.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M121.93,255.1c0-.32,1.77-17.66,2.87-28.37a21.26,21.26,0,0,0-4.13-14.92l-6.44-8.62a3.93,3.93,0,0,1,3.22-6.3c9.25.22,24.32,4.09,28.85,26.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M101.88,268.16l43.65-58a18.54,18.54,0,0,1,11-7l36.07-7.56a17.38,17.38,0,0,1,13.47,2.73L227.17,213a3.7,3.7,0,0,1-1.16,6.62,28.19,28.19,0,0,1-25.19-5.33,8.4,8.4,0,0,0-8.33-1.24l-16.43,6.62,8.55,48-29.87,8.88a27.42,27.42,0,0,0-11.66,7l-8.21,8.34Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 167.45,
    y: 218.06,
    width: 27.63,
    height: 15.87,
    rx: 7.62,
    transform: "translate(-19.81 17.43) rotate(-5.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 167.28,
    y: 235.21,
    width: 27.63,
    height: 15.87,
    rx: 7.62,
    transform: "translate(-21.37 17.49) rotate(-5.22)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 167.22,
    y: 252.52,
    width: 27.63,
    height: 15.87,
    rx: 7.62,
    transform: "matrix(1, -0.09, 0.09, 1, -22.95, 17.55)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogicalTestIcon);
export default __webpack_public_path__ + "static/media/logical_test_icon.c0cadd82b1f234710b83973ba97e8474.svg";
export { ForwardRef as ReactComponent };